import { Component, OnInit, OnDestroy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'how-it-works',
    templateUrl: './submissions.component.html',
    standalone: false
})
export class HowItWorksSubmissionsComponent implements OnInit, OnDestroy {
    constructor(
        private metaService: Meta,
        private titleService: Title
    ) {}

    ngOnInit() {
        this.titleService.setTitle('SGC Grading Scale');
        this.metaService.addTag( { name: 'description', content: 'With a brand new, interactive online submission form, submitting cards for grading and autographs for authentication has never been easier.' });
    }

    ngOnDestroy() {
        this.metaService.removeTag("name='description'");
    }

    grades = [
        {
            value: "10 PRI",
            quality: "Pristine",
            description: `A "virtually flawless" card. 50/50 centering, crisp focus, four sharp corners*, free of stains, no breaks in surface gloss, no print or refractor lines, and no visible wear under magnification.`
        },
        {
            value: "10 GM",
            quality: "GEM",
            description: `55/45 or better centering, sharp focus, four sharp corners*, free of stains, no breaks in surface gloss, no print or refractor lines, and no visible wear. A slight print spot visible under close scrutiny is allowable if it does not detract from the aesthetics of the card.`
        },
        {
            value: "9.5",
            quality: "MINT+",
            description: `Is a card that at first glance appears to be Gem Mint 10 upon close inspection it may have a tiny flaw(s) that keeps it from grading GEM MT 10.`
        },
        {
            value: "9",
            quality: "MINT",
            description: `60/40 or better centering, sharp focus and four sharp corners*. A minor flaw may exist upon close examination. A minor flaw may be, but is not limited to: a slight nick to one corner, a small gloss break or surface scratch, a minor print line or minor refractor line, a minor focus or color imperfection, or a small print spot.`
        },
        {
            value: "8.5",
            quality: "NM/MT+",
            description: `65/35 or better centering, four sharp corners*. A few minor flaws may exist upon close examination. A minor flaw may be, but is not limited to: a slight nick to one corner, a small gloss break or surface scratch, a minor print line or minor refractor line, a minor focus or color imperfection, or a small print spot.`
        },
        {
            value: "8",
            quality: "NM/MT",
            description: `65/35 or better centering, corners sharp to the naked eye but may exhibit slight wear under closer examination. A few small flaws may exist upon close examination. A small flaw may be, but is not limited to: very minor wear on one corner, a gloss break or surface scratch, a print line or refractor line, a focus or color imperfection, or a print spot.`
        },
        {
            value: "7.5",
            quality: "NM+",
            description: `70/30 or better centering, a few small flaws may exist upon close examination. A small flaw may be, but is not limited to: very minor wear on one corner, a gloss break or surface scratch, a print line or refractor line, a focus or color imperfection, or a print spot.`
        },
        {
            value: "7",
            quality: "NRMT",
            description: `70/30 or better centering, slight wear on some corners, minor scratching, some print spots or speckling, and print lines or refractor lines are acceptable. Card may exhibit a slightly skewed (diamond) cut.`
        },
        {
            value: "6.5",
            quality: "EX/NM+",
            description: `An EX/NM card that exhibits high-end overall quality and eye appeal.`
        },
        {
            value: "6",
            quality: "EX/NM",
            description: `75/25 or better centering, slight fuzzing of corners may be evident, skewed cut may be more evident, focus or register may be off, and slight notching of edges may exist.`
        },
        {
            value: "5.5",
            quality: "EX+",
            description: `An EX card that exhibits high-end overall quality and eye appeal.`
        },
        {
            value: "5",
            quality: "EX",
            description: `80/20 or better centering, minor rounding or fuzzing of corners, roughness or chipping along edge (no layering), one VERY slight surface or "spider" crease may exist on one side of the card, gloss may be lost from surface with some scratching that does not detract from the aesthetics of the card.`
        },
        {
            value: "4.5",
            quality: "VG/EX+",
            description: `A VG/EX card that exhibits high-end overall quality and eye appeal.`
        },
        {
            value: "4",
            quality: "VG/EX",
            description: `85/15 or better centering, corners are slightly rounded with modest surface wear. Light hairline crease may show on one or both sides. A light tear or surface break may exist.`
        },
        {
            value: "3.5",
            quality: "VG+",
            description: `A VG card that exhibits high-end overall quality and eye appeal.`
        },
        {
            value: "3",
            quality: "VG",
            description: `90/10 or better centering, corners more rounded--but not excessive, stronger creasing may exist. Poorer focus, registration, and discoloration, and staining are more noticeable.`
        },
        {
            value: "2.5",
            quality: "GOOD+",
            description: `A GOOD card that exhibits high-end overall quality and eye appeal.`
        },
        {
            value: "2",
            quality: "GOOD",
            description: `Centered 90/10 or better. This card usually exhibits one or more of these characteristics: heavy print spots, heavy crease(s), pinhole(s), color or focus imperfections or discoloration, surface scuffing or tear, rounded and/or fraying corners, ink or pencil marking(s), and lack of all or some original gloss.`
        },
        {
            value: "1.5",
            quality: "FAIR",
            description: `Centered 90/10 or better. This card usually exhibits several of these characteristics: heavy print spots, heavy crease(s), pinhole(s), color or focus imperfections or discoloration, surface scuffing or tears, rounded and/or fraying corners, ink or pencil marking(s), and lack of all or some original gloss, a small portion of the card may be missing.`
        },
        {
            value: "1",
            quality: "POOR",
            description: `This card usually exhibits many of these characteristics: heavy print spots, heavy crease(s), pinhole(s), color or focus imperfections or discoloration, surface scuffing or tears, rounded and/or fraying corners, ink or pencil marking(s), and lack of all or some original gloss, small portions of the card may be missing.`
        }
    ]

    selectedGrade:any = this.grades[0];

    selectGrade(grade: any) {
        this.selectedGrade = grade;
    }

    isSelected(grade: any): boolean {
        return this.selectedGrade == grade;
    }

}
